<template>
  <div class="main">
    <div
      style="
        background: #f3f3f3;
        padding: 20px;
        border-radius: 5px;
        max-width: 700px;
        display: flex;
        flex-direction: column;
        gap: 5px;
      "
    >
      <!-- <h2 style="font-size: 20px">Мы изменили систему авторизации</h2>
      <p>Теперь доступ в аккаунт осуществляется по паролю.</p>
      <p>
        Если ваша регистрация в сервисе была до перехода на новую систему
        авторизации и у вас нет пароля, нажмите на
        <a href="" @click.prevent="this.$router.push('/restore')"
          >Восстановить пароль</a
        >.
      </p>
      <p>
        Если возникнут трудности с получением пароля, напишите в
        <a href="https://t.me/doroved" target="_blank">поддержку</a>.
      </p>
      <p>
        Чтобы всегда быть в курсе всех новостей сервиса, подпишитесь на
        <a href="https://t.me/s/checkerFBRIP" target="_blank">канал</a>.
      </p> -->

        <h2 style="font-size: 20px">Мы изменили систему</h2>
      <p>Теперь сервис бесплатный для всех! Для использования чекера вам нужно подтвердить, что вы не бот
      </p>
      <p>
        Если возникнут трудности, напишите в
        <a href="https://t.me/bioshok333" target="_blank">поддержку</a>.
      </p>
      <p>
        Чтобы всегда быть в курсе всех новостей сервиса, подпишитесь на
        <a href="https://t.me/s/checkerFBRIP" target="_blank">канал</a>.
      </p>
    </div>

    <h1>Вы не бот?</h1>

    <div class="field-form">
      <div
        v-if="reqConnectTg"
        style="
          background: rgb(243, 243, 243);
          padding: 20px;
          border-radius: 5px;
          max-width: 700px;
          display: flex;
          flex-direction: column;
          gap: 5px;
          text-align: center;
        "
      >
        <p style="font-size: 14px">
          Чтобы подключить аккаунт к нашему боту, требуется авторизация.
        </p>
      </div>

      <!-- <div class="field-wrapper">
        <input
          v-model="email"
          @input="formatEmail"
          ref="inputEmail"
          type="email"
          placeholder="&nbsp;"
          spellcheck="false"
          autocomplete="off"
        />
        <label>Email</label>
      </div>

      <div class="field-wrapper">
        <input
          v-model="password"
          ref="inputPassword"
          type="password"
          placeholder="&nbsp;"
          spellcheck="false"
          autocomplete="off"
        />
        <label>Пароль</label>
      </div> -->

      <vue-recaptcha
        ref="recaptcha"
        @verify="onVerify"
        @expired="onExpired"
        sitekey="6Lf94DMeAAAAAERMa4Dxk3SCK6bYjXQ53gD2JxiS"
      ></vue-recaptcha>

      <button
        :disabled="loadingAuth /*|| !email || !password */|| !recaptchaResponse"
        @click="auth"
        type="submit"
      >
        Войти
      </button>
    </div>

    <!-- <div style="display: flex; gap: 10px">
      <button
        @click="this.$router.push('/reg')"
        style="
          display: flex;
          border: none;
          padding: 5px 10px;
          border-radius: 5px;
          cursor: pointer;
          font-size: inherit;
          font-family: inherit;
          box-shadow: rgb(189, 186, 186) 0px 5px 20px -6px;
          transition: all 0.2s ease-in 0s;
          background: #10787e;
          color: white;
          letter-spacing: inherit;
        "
      >
        У меня нет аккаунта :(
      </button>
      <button
        @click="this.$router.push('/restore')"
        style="
          display: flex;
          border: none;
          padding: 5px 10px;
          border-radius: 5px;
          cursor: pointer;
          font-size: inherit;
          font-family: inherit;
          box-shadow: rgb(189, 186, 186) 0px 5px 20px -6px;
          transition: all 0.2s ease-in 0s;
          background: #9d5609;
          color: white;
          letter-spacing: inherit;
        "
      >
        Восстановить пароль
      </button>
    </div> -->
  </div>
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha';
export default {
  components: { VueRecaptcha },
  data() {
    return {
      email: '',
      password: '',
      loadingAuth: false,
      reqConnectTg: false,
      recaptchaResponse: null,
    };
  },

  methods: {
    async auth() {
      this.loadingAuth = true;
      // const email = this.email;
      // const password = this.password;

      try {
        const response = await this.$store.dispatch('login', {
          // email,
          // password,
          recaptchaResponse: this.recaptchaResponse,
        });

        if (response.data.success) {
          console.log('redirect')
          // console.log(response.data.token)
           
          this.$router.push(this.$route.query.next || '/');
        } else {
          this.resetRecaptcha();
          this.showToaster(response.data.message);
        }

        this.loadingAuth = false;
      } catch (err) {
        console.log(err);
        this.showToaster('Неизвесная ошибка. Попробуйте еще раз');
      }
    },

    showToaster(msg) {
      this.$toast.show(msg, {
        position: 'top',
        // duration: false,
      });
    },

    formatEmail() {
      this.email = this.email.replace(/[^a-zA-Z0-9-_+@.]/g, '');
    },

    onVerify(response) {
      this.recaptchaResponse = response;
      this.showToaster('Спасибо, что не робот :)');
    },
    onExpired() {
      this.recaptchaResponse = null;
    },
    resetRecaptcha() {
      this.recaptchaResponse = null;
      this.$refs.recaptcha.reset();
    },
  },

  mounted() {
    // this.$refs.inputEmail.focus();

    // Показываем плашку с инфой для не авторизованных запросов по урлу коннекта бота ТГ
    if (
      this.$route.query?.next &&
      this.$route.query.next.indexOf('/tgbot/connect/') !== -1
    ) {
      this.reqConnectTg = true;
    }
  },
};
</script>

<style scoped>
.main {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 15px;
  min-height: calc(100vh - 46px);
  padding: 15px;
}

.header {
  position: sticky !important;
  top: 0px !important;
}
</style>